import { useEffect } from 'react';

const useBeforeUnload = (callback, isActive) => {
  useEffect(() => {
    if (!isActive) return;

    const handleBeforeUnload = (event) => {
      callback?.(event);

      event.preventDefault();
      event.returnValue = ''; // standard way to handle beforeunload do not prevent dialogs
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [callback, isActive]);
};

export default useBeforeUnload;
